import { useMemo } from 'react'
import { usePromo } from '../../hooks/promo/usePromo'
import { ExternalPromoMedia } from '../../interfaces/promo'
import { PreheaderData } from '../../interfaces/ui'
import { CarouselPreheaders } from './CarouselPreheaders'
import { PreHeader } from './PreHeader'

function toBanner(row: ExternalPromoMedia): PreheaderData {
    return {
        urlImgDesktop: row.desktop_url,
        urlImgMobile: row.mobile_url,
        linkToOpen: row.link?.trim() || undefined,
        name: row.title?.trim() || `preheader-${row.id}`,
        endDate: row.end_date ? String(row.end_date).slice(0, 10) : undefined,
    }
}

export const PreheaderMain = () => {
    const { externalPreheaders, externalPromosLoaded } = usePromo()
    const apiBanners = useMemo(
        () => externalPreheaders.map(toBanner),
        [externalPreheaders]
    )

    if (!externalPromosLoaded || externalPreheaders.length === 0) return null

    return (
        <div className="container">
            {externalPreheaders.length > 1 ? (
                <CarouselPreheaders banners={apiBanners} shuffle={true} />
            ) : (
                <PreHeader {...apiBanners[0]} key={externalPreheaders[0].id} />
            )}
        </div>
    )
}
